exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-toggle[data-v-054e695a]::after {\n  display: none;\n}\n", ""]);

// exports
